import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const DocumentPlusIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/document-plus"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M5.39998 1.6001C4.40586 1.6001 3.59998 2.40589 3.59998 3.4V20.6001C3.59998 21.5942 4.40586 22.4001 5.39998 22.4001H18.6C19.5941 22.4001 20.4 21.5942 20.4 20.6001V8.35C20.4 7.87261 20.2103 7.40757 19.8728 7.07L14.9272 2.13C14.5896 1.79243 14.1318 1.6001 13.6544 1.6001H5.39998ZM12 9.6C12.497 9.6 12.9 10.0029 12.9 10.5V12.3H14.7C15.197 12.3 15.6 12.7029 15.6 13.2C15.6 13.6971 15.197 14.1 14.7 14.1H12.9V15.9C12.9 16.3971 12.497 16.8 12 16.8C11.5029 16.8 11.1 16.3971 11.1 15.9V14.1H9.29997C8.80292 14.1 8.39997 13.6971 8.39997 13.2C8.39997 12.7029 8.80292 12.3 9.29997 12.3H11.1V10.5C11.1 10.0029 11.5029 9.6 12 9.6Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default DocumentPlusIcon;